import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { myApi } from "../api";

const CartContext = createContext(null);

/**
 * Global cart state for the MY area: keeps the latest cart snapshot in
 * memory so the topbar mini-cart and any other consumer can read item
 * counts / totals without re-fetching. `refresh()` re-pulls the server
 * state — call it whenever a cart mutation occurs anywhere in the UI.
 */
export function CartProvider({ children }) {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await myApi.cartGet();
      setCart(data?.obj || data || {});
    } catch {
      setCart({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const produtos = cart?.produtos || [];
  const packs = cart?.packs || [];
  const itemCount = produtos.length + packs.length;
  const total = Number(cart?.total ?? 0);
  const currency = cart?.ID_Moeda || "EUR";

  return (
    <CartContext.Provider value={{ cart, produtos, packs, itemCount, total, currency, loading, refresh }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside <CartProvider>");
  return ctx;
}
